import { render, staticRenderFns } from "./AssetDetail.vue?vue&type=template&id=6677a03e&"
import script from "./AssetDetail.vue?vue&type=script&lang=js&"
export * from "./AssetDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports